<template>
  <div class="fin-company-more-information">
    <div class="headline-section">Weitere Informationen</div>
    <v-row>
      <v-col v-if="companyPortrait" cols="12" sm="5">
        <div class="mb-5">
          <div class="title">
            Industrie
          </div>
          <p v-if="companyPortrait.industry">
            {{ companyPortrait.industry }}
          </p>
          <p v-else>-</p>
        </div>
        <div class="mb-5">
          <div class="title">
            Sektor
          </div>
          <p v-if="companyPortrait.sectorLevel0">
            {{ companyPortrait.sectorLevel0.name }}
          </p>
          <p v-else>-</p>
        </div>
      </v-col>
      <v-col v-else cols="12" sm="5">
        <p>Keine Informationen verfügbar</p>
      </v-col>
      <v-col cols="12" sm="5">
        <div class="mb-5">
          <div class="title">
            Ende des Finanzjahres
          </div>
          <p> {{ endOfFiscalYear }}</p>
        </div>
        <div class="mb-5">
          <div class="title">
            Streubesitz
          </div>
          <p> {{ freefloat }} </p>
        </div>
        <div class="mb-5">
          <div class="title">
            Gründungsdatum
          </div>
          <p> {{ foundingDate }} </p>
        </div>
      </v-col>
      <v-spacer/>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "fin-company-more-information",
  props: {
    companyPortrait: {
      type: Object
    }
  },
  computed: {
    // 20210908 - 1.0.0 - IPO enthält Gründungsdatum statt Tag des Börsengangs => TODO bereinigen
    foundingDate() {
      // 2017-06-01T00:00:00.000Z
      if (this.companyPortrait?.ipo) {
        return this.$options.filters.date(this.companyPortrait.ipo)
      } else return "-"
    },
    freefloat() {
      let valuePercent = "-"
      if (this.companyPortrait) {
        valuePercent = this.$options.filters.percent(this.companyPortrait.freeFloat)
      }
      if (valuePercent.includes("+", 0)) {
        valuePercent = valuePercent.substring(1)
      }
      return valuePercent
    },
    endOfFiscalYear() {
      // 03-31
      if (this.companyPortrait) {
        let value = this.companyPortrait.endOfFiscalYear
        try {
          let day = value.substring(3, 5)
          let month = value.substring(0, 2)
          let formattedValue = day + '.' + month
          return formattedValue
        } catch (e) {
          return value
        }
      } else return "-"
    }
  }
}
</script>

<style lang="scss" scoped>

.title {
  text-transform: uppercase;
  font-family: Gilroy !important;
  font-size: 12px !important;
  font-weight: 600;
}

::v-deep .tag {
  font-size: 14px;
}

</style>

